<template>
  <v-container>
    <div class="container my-5">
        <h2>プライバシーポリシー</h2>
        <div class="ml-4">
            <div class="mb-4">
                本プライバシーポリシーは、Kakeru Wakayamaが提供する当アプリにおいて、
                当アプリの利用者(以下『利用者』とします。)の個人情報もしくはそれに準ずる情報を取り扱う際に、当アプリが遵守する方針を示したものです。
            </div>
            <div class="mb-3">
                <h5>■ 基本方針</h5>
                当アプリは、個人情報の重要性を認識し、個人情報を保護することが社会的責務であると考え、個人情報に関する法令を遵守し、
                当アプリで取り扱う個人情報の取得、利用、管理を適正に行います。当アプリで収集した情報は、利用目的の範囲内で適切に取り扱います。
            </div>
            <div class="mb-3">
                <h5>■ 適用範囲</h5>
                本プライバシーポリシーは、当アプリにおいてのみ適用されます。
            </div>
            <div class="mb-3">
                <h5>■ 個人情報の収集</h5>
                当アプリは、広告配信のためにGoogle 広告、Google Admobを使用しています。
            </div>
            <div class="mb-3">
                <h5>■ 広告について</h5>
                当アプリでは、広告配信を目的として以下の広告配信事業者が利用者の情報を自動取得する場合がございます。
                取得する情報、利用目的、第三者への提供等につきましては、以下の広告配信事業者のアプリケーション・プライバシーポリシーのリンクよりご確認ください。
                <div class="mt-1 ml-4">
                    Google 広告に関するポリシー：<a href="https://policies.google.com/technologies/ads?hl=ja">https://policies.google.com/technologies/ads?hl=ja</a>
                </div>
            </div>
            <div class="mb-3">
                <h5>■ プライバシーポリシーの変更について</h5>
                当アプリは、個人情報に関して適用される日本の法令を遵守するとともに、本プライバシーポリシーの内容を適宜見直しその改善に努めます。修正された最新のプライバシーポリシーは常に本ページにて開示されます。
            </div>
            <div class="my-5" style="text-align: right">
                2020/09/15 策定
            </div>
        </div>
    </div>
  </v-container>
  </template>
  
  <script>
  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>